const linesOfInitialEntries = 4;

const getObjectIndexToSplit = (info = []) => {
    let total = 0;
    let temp;

    for (let i = 0; i < info.length; i++) {
        const { fieldList = [] } = info[i];
        for (var j = 0; j < fieldList.length; j++) {
            total = total + 1;
            if (total === linesOfInitialEntries) {
                temp = i;
            }
        }
    }

    if (total === linesOfInitialEntries) {
        temp = undefined;
    }
    return temp;
};

const generateContent = (info = [], enableToggle) => {
   
    if (!enableToggle) {
        return {
            defaultVisible: info,
            togglable: []
        }
    }

    const splitIndex = getObjectIndexToSplit(info);
    let total = 0;
    const splitData = {
        defaultVisible: [],
        togglable: []
    };

    if (typeof splitIndex === 'undefined') {
        return {
            defaultVisible: info,
            togglable: []
        };
    }

    for (let i = 0; i < info.length; i++) {
        const data = info[i];

        if (i < splitIndex) {
            total = total + data.fieldList.length;
            splitData.defaultVisible.push(data);
        } else if (i > splitIndex) {
            splitData.togglable.push(data);
        }
    }

    // Split Content fieldList logic
    const splitObject = info[splitIndex];
    const fieldListIndexSplit = linesOfInitialEntries - total;
    const toggleFieldList = [...splitObject.fieldList];
    const staticFieldList = toggleFieldList.splice(0, fieldListIndexSplit);

    splitData.defaultVisible.push({
        title: splitObject.title,
        fieldList: staticFieldList
    });

    splitData.togglable.unshift({
        title: splitObject.title,
        fieldList: toggleFieldList
    });

    return splitData;
};

export {
    generateContent,
    getObjectIndexToSplit
};
